import React, { Component } from 'react'
import TagManager from 'react-gtm-module'
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
} from 'react-router-dom'
import Login from './app/login/Login'
import { SignUp } from './app/signup/Signup'
import WorkspaceList from './app/workspace/WorkspaceList'
import 'bootstrap/dist/css/bootstrap.min.css'
import { ForgotPassword } from './app/forgotPassword/forgot'
import { VerifyLink } from './app/workspace/verification'
import { VerifyPasswordLink } from './app/forgotPassword/verification'
import AcceptInvitation from './app/invite'
import DirectSignup from './app/direct_signup'
import { withTracker } from './ga'
import mixpanel from 'mixpanel-browser'

const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_ID,
}

TagManager.initialize(tagManagerArgs)

mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, {
    debug: process.env.REACT_APP_MIX_PANEL_DEBUG === 'true',
})
if(window.location) {
    var url = new URL(window.location.href);
    var distinctId = url.searchParams.get("distinct_id");
    console.log("identifiing mix panel", decodeURIComponent(distinctId))
    mixpanel.identify(decodeURIComponent(distinctId));    
}

const LoginAndSignup = () => {
    return (
        <section className="bg_img_login">
            <Switch>
                <Route
                    exact
                    path={process.env.REACT_APP_UI_BASE_URL}
                    component={Login}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_SIGNUP,
                    ].join('')}
                    component={SignUp}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_NEW_WORKSPACE,
                    ].join('')}
                    component={VerifyLink}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_INVITATION_SIGNUP,
                    ].join('')}
                    component={AcceptInvitation}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_SELECT_WORKSPACE_URL,
                    ].join('')}
                    component={WorkspaceList}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_FORGOT_PASSWORD_URL,
                    ].join('')}
                    component={ForgotPassword}
                />

                <Route
                    exact
                    path={[
                        process.env.REACT_APP_UI_BASE_URL,
                        process.env.REACT_APP_UI_PASSWORD_RESET,
                    ].join('')}
                    component={VerifyPasswordLink}
                />

                <Redirect
                    exact
                    from="*"
                    to={process.env.REACT_APP_UI_BASE_URL}
                />
            </Switch>
        </section>
    )
}

class App extends Component {
    render() {
        console.log(
            [
                process.env.REACT_APP_UI_BASE_URL,
                process.env.REACT_APP_UI_DIRECT_SIGNUP,
            ].join('')
        )
        return (
            <Router>
                <Switch>
                    <Route
                        component={withTracker(DirectSignup)}
                        exact
                        path={[
                            process.env.REACT_APP_UI_BASE_URL,
                            process.env.REACT_APP_UI_DIRECT_SIGNUP,
                        ].join('')}
                    />
                    <Route
                        component={withTracker(LoginAndSignup)}
                        path={process.env.REACT_APP_UI_BASE_URL}
                    />
                </Switch>
            </Router>
        )
    }
}

export default App
